import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import News from '@/components/News'
import Partner from '@/components/Partner'
import Solution from '@/components/Solution'
import AboutUs from '@/components/AboutUs'
import ContactUs from '@/components/ContactUs'
import JoinUs from '@/components/JoinUs'
import Product from '@/components/Product'
import newJoinUs from '@/components/newJoinUs'
Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/Partner',
            name: 'Partner',
            component: Partner
        },
        // {
        //     path: '/Product',
        //     name: 'Product',
        //     component: Product,
        //     children: [{
        //             path: 'smartRobot',
        //             name: 'smartRobot',
        //             component: resolve => require(['../components/common/products/SmartRobot'], resolve)
        //         },
        //         {
        //             path: 'smartTerminal',
        //             name: 'smartTerminal',
        //             component: resolve => require(['../components/common/products/SmartTerminal'], resolve)
        //         },
        //         {
        //             path: 'smartCar',
        //             name: 'smartCar',
        //             component: resolve => require(['../components/common/products/SmartCar'], resolve)
        //         },
        //         // {
        //         //     path: 'smartChip',
        //         //     name: 'smartChip',
        //         //     component: resolve => require(['../components/common/products/smartChip'], resolve)
        //         // }
        //     ]
        // },
      {
        path: '/News',
        name: 'News',
        component: News,
        children: [{
          path: 'smartRobot',
          name: 'smartRobot',
          component: resolve => require(['../components/common/products/SmartRobot'], resolve)
        }
        ]
      },
        {
            path: '/Solution',
            name: 'Solution',
            component: Solution,
            children: [{
                    path: 'airPort',
                    name: 'airPort',
                    component: resolve => require(['../components/common/solutions/airPort/index'], resolve)
                },
                {
                    path: 'detection',
                    name: 'detection',
                    component: resolve => require(['../components/common/solutions/detection/index'], resolve)
                },
                {
                    path: 'education',
                    name: 'education',
                    component: resolve => require(['../components/common/solutions/education/index'], resolve)

                },
                {
                    path: 'medical',
                    name: 'medical',
                    component: resolve => require(['../components/common/solutions/medical/index'], resolve)
                },
                {
                    path: 'park',
                    name: 'park',
                    component: resolve => require(['../components/common/solutions/park/index'], resolve)
                },
                {
                    path: 'port',
                    name: 'port',
                    component: resolve => require(['../components/common/solutions/port/index'], resolve)
                },
                {
                    path: 'traffic',
                    name: 'traffic',
                    component: resolve => require(['../components/common/solutions/traffic/index'], resolve)
                }
            ]
        },
        {
            path: '/ContactUs',
            name: 'ContactUs',
            component: ContactUs
        },
        {
            path: '/AboutUs',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/JoinUs',
            name: 'JoinUs',
            component: newJoinUs
        },
        // 门禁测温说明书1.1
        {
            path: '/cb1852144b1b1910/2022cca12f9c4952', //中文
            name: 'cewenmenjin-1.1-cn',
            component: resolve => require(['../components/Instructions/cewenmenjin1.1/InstructionsCn'], resolve)
        },
        {
            path: '/cb1852144b1b1910/81e607ec7de27f2a', //英文
            name: 'cewenmenjin-1.1-en',
            component: resolve => require(['../components/Instructions/cewenmenjin1.1/InstructionsEn'], resolve)
        },
        // 门禁测温说明书2.0
        {
            path: '/5ffbcdca37ecb4a3/1d1299d7e8bf2d8f', //中文
            name: 'cewenmenjin-2.0-cn',
            component: resolve => require(['../components/Instructions/cewenmenjin2.0/InstructionsCn'], resolve)
        },
        {
            path: '/5ffbcdca37ecb4a3/fc08b96bd88baa3c', //英文
            name: 'cewenmenjin-2.0-en',
            component: resolve => require(['../components/Instructions/cewenmenjin2.0/InstructionsEn'], resolve)
        },
        //门禁2.0
        {
            path: '/05f76f431bf4839f/d230b856b2ff2f3d', //中文
            name: 'menjin-2.0-cn',
            component: resolve => require(['../components/Instructions/menjin2.0/InstructionsCn'], resolve)
        },
        {
            path: '/05f76f431bf4839f/fbfd545df52c8fb2', //英文
            name: 'menjin-2.0-en',
            component: resolve => require(['../components/Instructions/menjin2.0/InstructionsEn'], resolve)
        },
        // 门禁1.1
        {
            path: '/a2de60887f3bc38e/199c25c2939f7009', //中文
            name: 'menjin-1.1-cn',
            component: resolve => require(['../components/Instructions/menjin1.1/InstructionsCn'], resolve)
        },
        {
            path: '/a2de60887f3bc38e/5bc99c2d40a4cb3e', //英文
            name: 'menjin-1.1-en',
            component: resolve => require(['../components/Instructions/menjin1.1/InstructionsEn'], resolve)
        },
    ]
})

router.beforeEach((to, from, next) => {
    // 新增路由守卫，确保语言正确
    let fromQuery = from.query
    let toQuery = to.query
    if (fromQuery.lang && !toQuery.lang) {
        next({
            path: to.path,
            params: to.params,
            name: to.name,
            query: Object.assign(toQuery, { lang: fromQuery.lang })
        })
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js